module.exports = __webpack_public_path__ + "img/productFea3.d3d8d8e9.png";